<template>
  <div id="projectTask" v-if="resetPro">
    <div class="taskContainer">
      <el-tabs v-model="projectTaskActive" @tab-click="handleClick">
        <el-tab-pane label="立项" name="1">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList1"
              :key="item"
              @click="handleTaskBarClick1(item)"
              :class="activeTaskBar1===item?'activeTaskLi':''"
            >
              <span :title="item" class="overFlow" style="margin-left:20px">{{item}}</span>
              <div class="right">
                <!-- <img
                  style="width:25px"
                  v-if="item==='工作计划'"
                  src="../../../assets/image/icon_sc3@2x.png"
                  alt
                />-->
                <!-- <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt /> -->
                <!-- <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt /> -->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <project-register v-if="activeTaskBar1==='项目登记'"></project-register>
            <project-appointment v-if="activeTaskBar1==='项目组任命书'"></project-appointment>
            <keep-alive>
              <project-allocation v-if="activeTaskBar1==='项目分配'"></project-allocation>
            </keep-alive>
            <project-plan v-if="activeTaskBar1==='工作计划'"></project-plan>
            <project-risk v-if="activeTaskBar1==='风险分析'"></project-risk>
          </div>
        </el-tab-pane>
        <el-tab-pane label="现场调查" v-if="!is_demand_type" :disabled="disabledTabs2" name="2">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList2"
              :key="item"
              @click="handleTaskBarClick2(item)"
              :class="activeTaskBar2===item?'activeTaskLi':''"
            >
              <span :title="item" class="overFlow" style="margin-left:20px;font-size:16px">{{item}}</span>
              <div class="right">
                <!-- <img
                  style="width:25px"
                  v-if="item==='整改复查记录表' || item==='委托方提供材料清单'"
                  src="../../../assets/image/icon_sc3@2x.png"
                  alt
                />
                <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt />-->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <prospecting-form v-if="activeTaskBar2==='现场勘察记录'"></prospecting-form>
            <change-inform v-if="activeTaskBar2==='整改通知单'"></change-inform>
            <change-history v-if="activeTaskBar2==='整改复查记录表'"></change-history>
          </div>
        </el-tab-pane>
        <el-tab-pane label="三级审核" v-if="!is_demand_type" :disabled="disabledTabs3" name="3">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList3"
              :key="item"
              @click="handleTaskBarClick3(item)"
              :class="activeTaskBar3===item?'activeTaskLi':''"
            >
              <span :title="item" class="overFlow" style="margin-left:20px">{{item}}</span>
              <div class="right">
                <!-- <img
                  style="width:25px"
                  v-if="item==='报告审定' ||item==='外部审查(非必须)'"
                  src="../../../assets/image/icon_sc3@2x.png"
                  alt
                />
                <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt />-->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <in-side v-if="activeTaskBar3==='项目内部审核'"></in-side>
            <!-- <report-judgement v-if="activeTaskBar3==='报告审定'"></report-judgement> -->
            <technical-people v-if="activeTaskBar3==='技术负责人审核'"></technical-people>
            <process-people v-if="activeTaskBar3==='过控负责人审核'"></process-people>
          </div>
        </el-tab-pane>
        <el-tab-pane label="外部审查" v-if="!is_demand_type" :disabled="disabledTabs6" name="6">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList6"
              :key="item"
              @click="handleTaskBarClick6(item)"
              :class="activeTaskBar6===item?'activeTaskLi':''"
            >
              <span :title="item" class="overFlow" style="margin-left:20px">{{item}}</span>
              <div class="right">
                <!-- <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt />-->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <out-side v-if="activeTaskBar6==='外部审查'"></out-side>
          </div>
        </el-tab-pane>
        <el-tab-pane label="报告盖章" v-if="!is_demand_type" :disabled="disabledTabs4" name="4">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList4"
              :key="item"
              @click="handleTaskBarClick4(item)"
              :class="activeTaskBar4===item?'activeTaskLi':''"
            >
              <span
                :title="item"
                :class="item==='评价报告成品检验记录'?'fontSize14':''"
                class="overFlow"
                style="margin-left:20px;font-size:16px"
              >{{item}}</span>
              <div class="right">
                <!-- <img style="width:25px" src="../../../assets/image/icon_sc3@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt />-->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <!-- <evaluation-report v-if="activeTaskBar4==='评价报告成品检验记录'"></evaluation-report> -->
            <!-- <satisfaction-survey v-if="activeTaskBar4==='顾客满意度调查表'"></satisfaction-survey> -->
            <!-- <publicity-history v-if="activeTaskBar4==='项目网上公示记录'"></publicity-history> -->
            <use-apply v-if="activeTaskBar4==='资质/印章使用申请'"></use-apply>
          </div>
        </el-tab-pane>
        <el-tab-pane label="存档" v-if="!is_demand_type" :disabled="disabledTabs5" name="5">
          <!-- 左侧边 -->
          <ul class="leftSelect">
            <li
              v-for="item in leftBarList5"
              :key="item"
              @click="handleTaskBarClick5(item)"
              :class="activeTaskBar5===item?'activeTaskLi':''"
            >
              <span :title="item" class="overFlow" style="margin-left:20px;font-size:16px">{{item}}</span>
              <div class="right">
                <!-- <img
                  style="width:25px"
                  v-if="item==='委托方提供材料清单'"
                  src="../../../assets/image/icon_sc3@2x.png"
                  alt
                />
                <img style="width:18px" src="../../../assets/image/icon_xgai@2x.png" alt />
                <img style="width:18px" src="../../../assets/image/icon_del@2x.png" alt />-->
              </div>
            </li>
            <!-- <li class="taskBarLastLi">
              <img
                style="width:25px;margin:20px 0 8px"
                src="../../../assets/image/icon_tjrw@2x.png"
                alt
              />
              <span style="font-size:14px">添加任务</span>
            </li>-->
          </ul>
          <!-- 右边主体 -->
          <div class="rightComponents">
            <materials-list v-if="activeTaskBar5==='委托方提供材料清单'"></materials-list>
            <save-list v-if="activeTaskBar5==='项目档案存档清单'"></save-list>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// 立项-项目登记
import ProjectRegister from '../../../components/project/ProjectRegister'
// 立项-项目任命书
import ProjectAppointment from '../../../components/project/ProjectAppointment'
// 立项-项目分配
import ProjectAllocation from '../../../components/project/ProjectAllocation'
// 立项-工作计划
import ProjectPlan from '../../../components/project/ProjectPlan'
// 立项-风险分析
import ProjectRisk from '../../../components/project/ProjectRisk'
// 现场调查-现场勘察记录
import ProspectingForm from '../../../components/fieldInvestigation/ProspectingForm'
// 现场调查-整改通知单
import ChangeInform from '../../../components/fieldInvestigation/ChangeInform'
// 现场调查-整改复查记录表
import ChangeHistory from '../../../components/fieldInvestigation/ChangeHistory'
// 现场调查-委托方提供材料清单
import MaterialsList from '../../../components/fieldInvestigation/MaterialsList'
// 三级审核-项目内部审核
import InSide from '../../../components/threeLevel/InSide'
// 三级审核-报告审定
// import ReportJudgement from '../../../components/threeLevel/ReportJudgement'
import TechnicalPeople from '../../../components/threeLevel/TechnicalPeople'
import ProcessPeople from '../../../components/threeLevel/ProcessPeople'

// 三级审核-外部审查(非必须)
import OutSide from '../../../components/threeLevel/OutSide'
// 报告盖章-资质/印章使用申请
import UseApply from '../../../components/reportStamp/UseApply'
// 报告盖章-项目网上公示记录
import PublicityHistory from '../../../components/reportStamp/PublicityHistory'
// 报告盖章-评价报告成品检验记录
import EvaluationReport from '../../../components/reportStamp/EvaluationReport'
// 报告盖章-顾客满意度调查表
import SatisfactionSurvey from '../../../components/reportStamp/SatisfactionSurvey'
// 存档-项目档案存档清单
import SaveList from '../../../components/save/SaveList'
export default {
  name: 'projectAdd',
  data() {
    return {
      resetPro: true,
      disabledTabs2: false,
      disabledTabs3: false,
      disabledTabs4: false,
      disabledTabs5: false,
      disabledTabs6: false,
      isEdit: '1',
      member_id: '',
      token: '',
      company_id: '',
      cache_department_id: '',
      // activeTaskBar1: '项目登记',
      activeTaskBar1: '',
      // activeTaskBar2: '现场勘察记录',
      activeTaskBar2: '',
      // activeTaskBar3: '项目内部审核',
      activeTaskBar3: '',
      // activeTaskBar4: '资质/印章使用申请',
      activeTaskBar4: '',
      // activeTaskBar5: '项目档案存档清单',
      activeTaskBar5: '',
      // activeTaskBar6: '外部审查',
      activeTaskBar6: '',
      activeLeftBar: '1',
      // projectTaskActive: '1',
      projectTaskActive: '',
      // leftBarList1: [
      //   '项目评价风险分析表',
      //   '项目登记',
      //   '项目分配',
      //   '项目组任命书',
      //   '项目计划方案',
      // ],
      leftBarList1: [
        '风险分析',
        '项目登记',
        '项目分配',
        '项目组任命书',
        '工作计划',
      ],
      // leftBarList2: [
      //   '项目现场勘察表',
      //   '整改通知单',
      //   '整改复查记录表',
      //   '委托方提供材料清单',
      // ],
      leftBarList2: ['现场勘察记录', '整改通知单', '整改复查记录表'],

      // leftBarList3: ['内部审核', '报告审定', '外部审查(非必须)'],
      leftBarList3: ['项目内部审核', '技术负责人审核', '过控负责人审核'],
      // leftBarList4: [
      //   '评价报告成品检验记录',
      //   '顾客满意度调查表',
      //   '项目网上公示记录',
      //   '资质/印章使用申请',
      // ],
      leftBarList4: ['资质/印章使用申请'],
      leftBarList5: ['委托方提供材料清单', '项目档案存档清单'],
      leftBarList6: ['外部审查'],
      // 是否申请项目编号(判断是否隐藏顶边侧边栏)
      is_demand_type: false,
    }
  },
  methods: {
    handleMarginRight() {
      this.$nextTick(() => {
        let a = document.getElementsByClassName('el-tabs__active-bar')
        a[0].style.marginLeft = '50px'
      })
    },
    // 判断项目状态
    judgeProjectStatus() {
      if (this.project_status === '11') {
        this.projectTaskActive = '1'
        this.activeTaskBar1 = '项目登记'
      }
      if (this.project_status === '12') {
        this.projectTaskActive = '1'
        this.activeTaskBar1 = '项目分配'
      }
      if (this.project_status === '13') {
        this.projectTaskActive = '1'
        this.activeTaskBar1 = '风险分析'
      }
      if (this.project_status === '14') {
        this.projectTaskActive = '1'
        this.activeTaskBar1 = '项目组任命书'
      }
      if (this.project_status === '15') {
        this.projectTaskActive = '1'
        this.activeTaskBar1 = '工作计划'
      }
      if (this.project_status === '21') {
        this.projectTaskActive = '2'
        this.activeTaskBar2 = '现场勘察记录'
        this.handleMarginRight()
      }
      if (this.project_status === '22') {
        this.projectTaskActive = '2'
        this.activeTaskBar2 = '整改通知单'
        this.handleMarginRight()
      }
      if (this.project_status === '23') {
        this.projectTaskActive = '2'
        this.activeTaskBar2 = '整改复查记录表'
        this.handleMarginRight()
      }
      if (this.project_status === '24') {
        // 改动
        this.projectTaskActive = '5'
        this.activeTaskBar5 = '委托方提供材料清单'
      }
      // !!!!!改动
      if (this.project_status === '311' || this.project_status === '312') {
        this.projectTaskActive = '3'
        this.activeTaskBar3 = '项目内部审核'
        this.handleMarginRight()
      }
      // !!!!!改动(拆分减少)
      if (this.project_status == '321' || this.project_status == '322') {
        this.projectTaskActive = '3'
        this.activeTaskBar3 = '技术负责人审核'
        this.handleMarginRight()
      }
      // !改动(拆分新增)
      if (this.project_status === '323' || this.project_status === '324') {
        this.projectTaskActive = '3'
        this.activeTaskBar3 = '过控负责人审核'
        this.handleMarginRight()
      }
      // !!!!!改动
      // 外部审查 tabs 6
      if (this.project_status === '33') {
        this.projectTaskActive = '6'
        this.activeTaskBar6 = '外部审查'
        this.handleMarginRight()
      }
      if (this.project_status === '41') {
        this.projectTaskActive = '4'
        this.activeTaskBar4 = '评价报告成品检验记录'
        this.handleMarginRight()
      }
      if (this.project_status === '42') {
        this.projectTaskActive = '4'
        this.activeTaskBar4 = '顾客满意度调查表'
        this.handleMarginRight()
      }
      if (this.project_status === '43') {
        this.projectTaskActive = '4'
        this.activeTaskBar4 = '项目网上公示记录'
        this.handleMarginRight()
      }
      if (this.project_status === '44') {
        this.projectTaskActive = '4'
        this.activeTaskBar4 = '资质/印章使用申请'
        this.handleMarginRight()
      }
      if (this.project_status === '51') {
        this.projectTaskActive = '5'
        this.activeTaskBar5 = '项目档案存档清单'
      }
      if (this.project_status === '60') {
        this.projectTaskActive = '5'
        this.activeTaskBar5 = '项目档案存档清单'
      }
      if (this.$route.query.formFinance == '1') {
        this.projectTaskActive = '1'
        return (this.activeTaskBar1 = '项目登记')
      }
      // 判断仅用于获取合同编号
      if (this.$route.query.demand_type == '2') {
        // 是申请项目编号
        this.is_demand_type = true
        this.leftBarList1 = ['项目登记']
        this.projectTaskActive = '1'
        return (this.activeTaskBar1 = '项目登记')
      }
      // 快速存档
      if (this.$route.query.is_over == '1') {
        // 是申请项目编号
        this.disabledTabs5 = false
        this.projectTaskActive = '5'
        this.activeTaskBar5 = '项目档案存档清单'
      }
    },
    // !改动!
    handleTaskBarClick6(val) {
      this.activeTaskBar6 = val
    },
    handleTaskBarClick5(val) {
      //委托方提供材料清单
      if (this.project_status === '24') {
        // 存档不能点击
        if (val == '项目档案存档清单') {
          return
        }
      }

      // 快捷存档来,并且项目状态不为委托
      if (
        (this.project_status != '24' ||
          this.project_status != '51' ||
          this.project_status != '60') &&
        this.$route.query.is_over == '1'
      ) {
        if (val == '委托方提供材料清单') {
          return
        }
      }
      this.activeTaskBar5 = val
    },
    handleTaskBarClick4(val) {
      if (this.project_status === '41') {
        return
      }
      if (this.project_status === '42') {
        if (val == '项目网上公示记录' || val == '资质/印章使用申请') {
          return
        }
      }
      if (this.project_status === '43') {
        if (val == '资质/印章使用申请') {
          return
        }
      }

      this.activeTaskBar4 = val
    },
    // !!!!!改动
    handleTaskBarClick3(val) {
      if (this.project_status === '311' || this.project_status === '312') {
        return
      }
      if (this.project_status === '321' || this.project_status === '322') {
        if (val == '过控负责人审核') {
          return
        }
      }
      console.log(val)
      this.activeTaskBar3 = val
    },
    handleTaskBarClick2(val) {
      if (this.project_status === '21') {
        // if (
        //   val == '整改通知单' ||
        //   val == '整改复查记录表' ||
        //   val == '委托方提供材料清单'
        // ) {
        //   return
        // }
        if (val == '整改通知单' || val == '整改复查记录表') {
          return
        }
      }
      if (this.project_status === '22') {
        // if (val == '整改复查记录表' || val == '委托方提供材料清单') {
        //   return
        // }
        if (val == '整改复查记录表') {
          return
        }
      }
      if (this.project_status === '23') {
        // if (val == '委托方提供材料清单') {
        //   return
        // }
      }
      this.activeTaskBar2 = val
    },
    handleTaskBarClick1(val) {
      if (this.isEdit == '0') return
      if (this.project_status === '11') {
        return
      }
      if (this.project_status === '12') {
        if (val == '风险分析' || val == '项目组任命书' || val == '工作计划') {
          return
        }
      }
      if (this.project_status === '13') {
        if (val == '项目组任命书' || val == '工作计划') {
          return
        }
      }
      if (this.project_status === '14') {
        if (val == '工作计划') {
          return
        }
      }
      this.activeTaskBar1 = val
    },
    handleClick(tab, event) {
      console.log('activeTaskBar3', tab.name)
      // if(this.isEdit=='0')
      if (
        tab.name == '2' ||
        tab.name == '3' ||
        tab.name == '4' ||
        tab.name == '6'
      ) {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
      } else {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '30px'
        })
      }
      if (tab.name == '1') {
        this.activeTaskBar1 = '项目登记'
      } else if (tab.name == '2') {
        if (this.activeTaskBar2 == '现场勘察记录') return
        this.activeTaskBar2 = '现场勘察记录'
      } else if (tab.name == '3') {
        if (this.activeTaskBar3 == '项目内部审核') return
        this.activeTaskBar3 = '项目内部审核'
      } else if (tab.name == '4') {
        if (this.activeTaskBar4 == '资质/印章使用申请') return
        this.activeTaskBar4 = '资质/印章使用申请'
      } else if (tab.name == '5') {
        if (this.activeTaskBar5 == '项目档案存档清单') return
        this.activeTaskBar5 = '项目档案存档清单'
      } else if (tab.name == '6') {
        if (this.activeTaskBar6 == '外部审查') return
        this.activeTaskBar6 = '外部审查'
      }
    },
    sideBarClick(val) {
      this.activeLeftBar = val
    },
    async getProjectStatus() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('project_id', this.project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_project_status',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.project_status = res.datas.project_status
      if (this.$route.query.formFinance == '1') {
        this.$route.query.project_status = this.project_status
      }
      // 通过项目状态禁用tabs
      if (
        this.project_status == '11' ||
        this.project_status == '12' ||
        this.project_status == '13' ||
        this.project_status == '14' ||
        this.project_status == '15'
      ) {
        // 立项阶段
        this.disabledTabs2 =
          this.disabledTabs3 =
          this.disabledTabs4 =
          this.disabledTabs5 =
          this.disabledTabs6 =
            true
      }
      if (
        this.project_status == '21' ||
        this.project_status == '22' ||
        this.project_status == '23'
      ) {
        // 现场调查阶段
        this.disabledTabs3 =
          this.disabledTabs4 =
          this.disabledTabs5 =
          this.disabledTabs6 =
            true
      }
      if (
        this.project_status == '311' ||
        this.project_status == '312' ||
        this.project_status == '321' ||
        this.project_status == '322' ||
        this.project_status == '323' ||
        this.project_status == '324'
      ) {
        // 三级审核阶段
        this.disabledTabs4 = this.disabledTabs5 = this.disabledTabs6 = true
      }
      if (this.project_status == '33') {
        this.disabledTabs4 = this.disabledTabs5 = true
      }
      if (
        this.project_status == '41' ||
        this.project_status == '42' ||
        this.project_status == '43' ||
        this.project_status == '44'
      ) {
        // 报告盖章阶段
        this.disabledTabs5 = true
      }
      if (
        this.project_status == '41' ||
        this.project_status == '42' ||
        this.project_status == '43' ||
        this.project_status == '44'
      ) {
        // 报告盖章阶段
        this.disabledTabs5 = true
      }

      if (this.project_status && this.project_id) {
        this.judgeProjectStatus()
      }
    },
    watchrouter() {
      // 判断是否侧重部门
      if (this.$route.query.fromIndex == '1') {
        this.token = localStorage.getItem('btlh_process_token') || ''
        this.member_id = localStorage.getItem('btlh_process_member_id') || ''
        this.company_id =
          localStorage.getItem('bthl_process_LoginCompanyId') || ''
        this.cache_department_id =
          localStorage.getItem('bthl_process_cache_department_id_store') || ''

        this.project_id = this.$route.query.project_id || ''
        if (this.$route.query.type == 'addPage') {
          this.projectTaskActive = '1'
          this.activeTaskBar1 = '项目登记'
        }
        if (this.$route.path == '/project/add/task') {
          this.isEdit = '0'
          return (this.disabledTabs2 =
            this.disabledTabs3 =
            this.disabledTabs4 =
            this.disabledTabs5 =
              true)
        }
        this.$router.go(0)
        // 获取项目编号并判断状态
        this.getProjectStatus()
      }
    },
  },
  activated() {
    // this.token = localStorage.getItem('btlh_process_token') || ''
    // this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    // this.project_id = this.$route.query.project_id || ''
    // if (this.$route.query.type == 'addPage') {
    //   this.projectTaskActive = '1'
    //   this.activeTaskBar1 = '项目登记'
    // }
    // if (this.$route.path == '/project/add/task') {
    //   this.isEdit = '0'
    //   return (this.disabledTabs2 =
    //     this.disabledTabs3 =
    //     this.disabledTabs4 =
    //     this.disabledTabs5 =
    //       true)
    // }
    // // 获取项目编号并判断状态
    // this.getProjectStatus()
  },
  created() {
    // 判断是否申请项目编号
    if (this.$route.query.demand_type == '2') {
      // 是申请项目编号
      this.is_demand_type = true
      this.leftBarList1 = ['项目登记']
    }
    if (this.$route.query.is_over == '1') {
      // 是存档
      // this.is_demand_type = true
      // this.leftBarList1 = ['项目登记']
    }
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.project_id = this.$route.query.project_id || ''
    if (this.$route.query.type == 'addPage') {
      this.projectTaskActive = '1'
      this.activeTaskBar1 = '项目登记'
    }
    if (this.$route.path == '/project/add/task') {
      this.isEdit = '0'
      return (this.disabledTabs2 =
        this.disabledTabs3 =
        this.disabledTabs4 =
        this.disabledTabs5 =
          true)
    }
    // 获取项目编号并判断状态
    this.getProjectStatus()
    // this.project_status = this.$route.query.project_status || ''
  },
  watch: {
    $route: 'watchrouter', //路由变化时，执行的方法
  },
  components: {
    ProjectRegister,
    ProjectAppointment,
    ProjectAllocation,
    ProjectPlan,
    ProjectRisk,
    InSide,
    // ReportJudgement,
    TechnicalPeople,
    ProcessPeople,
    OutSide,
    UseApply,
    PublicityHistory,
    EvaluationReport,
    SatisfactionSurvey,
    ProspectingForm,
    ChangeHistory,
    ChangeInform,
    MaterialsList,
    SaveList,
  },
}
</script>
<style lang="less" scoped>
#projectTask {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  padding: 30px;
  .taskContainer {
    width: 100%;
    // 撑开高度
    // height: auto;
    height: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    padding: 30px;
    .leftSelect {
      // width: 280px;
      width: 23%;
      max-width: 280px;
      box-sizing: border-box;
      li {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        background-color: #f4f5f6;
        color: #666;
        width: 100%;
        height: 90px;
        margin-bottom: 10px;
        .overFlow {
          cursor: pointer;
          min-width: 140px;
          overflow: hidden; /*超出部分隐藏*/
          white-space: nowrap; /*不换行*/
          text-overflow: ellipsis; /*超出部分文字以...显示*/
        }
        .fontSize14 {
          font-size: 14px !important;
        }
        .right {
          img {
            margin-right: 10px;
          }
        }
      }
      .activeTaskLi {
        background-image: linear-gradient(to right, #bce0ff, #e8f4ff);
        border-left: 3px solid #40a0f2;
        color: #198df1;
      }
      .taskBarLastLi {
        display: flex;
        background-color: #f9fbfd;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
    }
    .rightComponents {
      box-sizing: border-box;
      padding-left: 50px;
      // width: 100%;
      width: 77%;
      height: 100%;
      overflow-y: auto;
    }
    .rightComponents::-webkit-scrollbar {
      width: 5px !important;
    }
    .rightComponents::-webkit-scrollbar-track {
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
      border-radius: 10px;
    }
    /* 滚动条滑块 */
    .rightComponents::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }
  }
}
#projectTask {
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: calc(100%);
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 40px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      width: 100%;
      height: calc(100% - 80px);
      .el-tab-pane {
        width: 100%;
        height: 100%;
        display: flex;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999999;
    font-weight: 700;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #409eff !important;
  }
  /deep/.el-tabs__item:hover {
    color: #409eff !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #666;
  }
  // *修改tabs样式
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
</style>
